import req from "@/util/req";


export default function planLine(option) {
	this.opt = "view";
	this.linePiece = {
		routePoints: [],
		freePoints: [],
		route: {
			pathPoint: "",
			pathArray: [],
			path: undefined
		}
	};
	let AMap = option.AMap || undefined;
	let icon = option.icon || undefined;
	let map = option.map || undefined;
	if (!map || !AMap) {
		console.error(配置高德地图实例异常);
		return;
	}
	let baseColor = option.baseColor || "#ff0000";
	let highLight = option.highLight || "#2EB689";
	let markers = [];
	let markersTow = [];
	let that = this;
	let routeMode;

	// 进行路线渲染
	this.drawAll = index => {
		// 路线点
		that.linePiece.routePoints = that.linePiece.routePoints.filter(item => {
			if (item.lon && item.lat) {
				return item;
			}
		});
		that.linePiece.routePoints.forEach(function(point, index3) {
			that.markerShow(point, index3);
		});
		// 待选点
		if (that.linePiece.freePoints.length != 0) {
			that.linePiece.freePoints = that.linePiece.freePoints.filter(item => {
				if (item.lon && item.lat) {
					return item;
				}
			});
			// if (this.opt == 'edit') {
			//   that.linePiece.freePoints.forEach(function (point, index2) {
			//     that.markerShowTow(point, index2);
			//   });
			// } else {
			that.linePiece.freePoints.forEach(function(point, index2) {
				that.markerShowForu(point, index2);
			});
			// }
		}
		req.post("", api.paramSetting, _r => {
			routeMode = _r.data.routeMode;
			// 路线
			if (routeMode != 3) {
				let line = that.linePiece.route;
				let midArray = [];
				if (line.pathPoint.length > 0) {
					midArray = line.pathPoint
						.substr(0, line.pathPoint.length - 1)
						.split(";");
				}
				// 把字符串转为数组
				line.pathArray = midArray.map(one => {
					if (one) {
						let coor = one.split(",");
						return new AMap.LngLat(coor[0], coor[1]);
					}
				});
				line.pathArray = line.pathArray.filter(item => {
					// if(item.lng == undefined){}
					if (item.lng && item.lat) {
						return item;
					}
				});
				// 渲染路线
				var polyline = new AMap.Polyline({
					path: line.pathArray,
					strokeWeight: 8, // 线条宽度，默认为 1
					strokeColor: that.opt == "edit" ? highLight : baseColor, // 线条颜色
					lineJoin: "round" // 折线拐点连接处样式
				});
				polyline.on("click", e => {
					plan1Edit(index);
				});
				// 将折线添加至地图实例
				map.add(polyline);
				line.path = polyline;
			}
			// else{
			// 	console.log(21312312)
			//      let line = that.linePiece.route;
			//      let midArray = [];
			//      if (line.pathPoint.length > 0) {
			//        midArray = (line.pathPoint.substr(0, line.pathPoint.length - 1)).split(";");
			//      }else{
			//        midArray = " ";
			//      }
			//      // 把字符串转为数组
			//      if(!line.pathArray){
			//        line.pathArray = midArray.map((one) => {
			//          if(one){
			//            let coor = one.split(",");
			//            return new AMap.LngLat(coor[0], coor[1])
			//          }
			//        })
			//        line.pathArray = line.pathArray.filter(item => {
			//          if (item.lng && item.lat) {
			//            return item
			//          }
			//        })
			//      }else{
			//        console.log(1)
			//        line.pathArray = []
			//      }
			//      // 渲染路线
			//      var polyline = new AMap.Polyline({
			//        path: line.pathArray,
			//        strokeWeight: 8, // 线条宽度，默认为 1
			//        strokeColor: that.opt == 'edit' ? highLight : baseColor, // 线条颜色
			//        lineJoin: 'round' // 折线拐点连接处样式
			//      });
			//      // 将折线添加至地图实例
			//      map.add(polyline);
			//      line.path = polyline;
			//    }
		});
	};
	this.removeRoutePoints = () => {
		that.linePiece.routePoints.forEach(point => {
			if (point.marker) {
				map.remove(point.marker);
				point.marker = undefined;
			}
		});
	};
	this.removeFreePoints = () => {
		that.linePiece.freePoints.forEach(point => {
			if (point.marker) {
				map.remove(point.marker);
				point.marker = undefined;
			}
		});
	};
	this.removeRoute = () => {
		if (that.linePiece.route.path) {
			map.remove(that.linePiece.route.path);
			that.linePiece.route.path = undefined;
		}
	};
	// 删除
	this.remove = () => {
		this.removeFreePoints();
		this.removeRoutePoints();
		this.removeRoute();
	};
	// 添加待选点
	this.addNewPoint = (point, index) => {
		// 在原数据里插入
		this.linePiece.routePoints.splice(index, 0, point);
		that.getNewRoute();
	};
	// 移除待选点
	this.removePoint = index => {
		this.linePiece.routePoints.splice(index, 1);
		markers[index].setMap(null);
		// map.remove([markers[index]])
		// markers.splice(index, 1);
		this.linePiece.freePoints.push(this.linePiece.routePoints[index]);
		that.getNewRoute();
	};
	// 从新进行数据请求
	var unitIdlist = "";
	this.getNewRoute = () => {
		//用routePoint里面的产生单位顺序请求预览 拿到新数据重新setdatas
		unitIdlist = this.linePiece.routePoints
			.map(item => {
				return item.unitId;
			})
			.join(",");
		let arr = this.linePiece.routePoints.map(item => {
			return item.unitId;
		});
		console.log(arr);
		var a = {
			unitIds: unitIdlist
		};
		// ctS_ctUnitConfig_ctUnitParams
		req.post("", api.paramSetting, _r => {
			console.log(_r.data);
			routeMode = _r.data.routeMode;
			if (_r.data.routeMode != 3) {
				//    req.post(a, api.ctS_get_Rou_getPlan, (_r) => {
				//      if (_r.data) {
				//        this.linePiece.route.pathPoint = _r.data
				//        that.setData(this.linePiece)
				//      } else {
				//        // that.setData(this.linePiece)
				//        that.showAllPoint()
				//        if (_r.message == '查询失败！') {
				//          _r.message = '该产生单位，暂无路线生成，请重新选择'
				//        }
				//      }
				// if(_r.success == false){
				// 	messageError(_r.message);
				// }
				//    })
			}
		});
	};
	var unitIdlistData = "";
	(this.getList = (index, index2) => {
		unitIdlistData = this.linePiece.routePoints.map(item => {
			return item.unitId;
		});

		// let first = unitIdlistData[0]
		// let last = unitIdlistData[unitIdlistData.length - 1]
		// unitIdlistData.shift()
		// unitIdlistData.pop()

		let value = unitIdlistData.splice(index - 1, 1)[0];
		let firstvalue = unitIdlistData.slice(0, index2 - 1);
		let residuevalue = unitIdlistData.slice(index2 - 1);
		let newArr = [...firstvalue, value, ...residuevalue];

		let data = [];

		newArr.forEach(item2 => {
			this.linePiece.routePoints.forEach(item => {
				if (item2 == item.unitId) {
					data.push(item);
				}
			});
		});
		data.shift();
		data.pop();
		// data.unshift(this.linePiece.routePoints[0])
		// data.push(this.linePiece.routePoints[this.linePiece.routePoints.length - 1])

		this.linePiece.routePoints = data;
	}),
	// 保存
	(this.saveRoute = (a, flag) => {
		//请求保存 取出当前routePoint请求保存
		let data = a;

		console.log(data, flag);
		data.unitIds = this.linePiece.routePoints
			.map(item => {
				return item.unitId;
			})
			.join(",");
		console.log(data)
		data = {
			param: JSON.stringify(data)
		};

		req.post(data, api.ctS_get_Rou_savePlan, _r => {
			// 数据状态标记还原
			this.opt = "view";
			refFreePoints();

			let vehicleForm = {
				planId: _r.data,
				carId: a.carId
			};

			if (flag) {
				req.post(vehicleForm, api.ctS_Rou_Updat, _r => {});
			}
		});
	});
	this.setData = function(data, index) {
		that.remove();
		// todo
		that.linePiece = data;
		that.drawAll(index);
	};
	this.hide = function() {
		that.linePiece.routePoints.forEach(point => {
			if (point.marker) {
				point.marker.hide();
			}
		});
		that.linePiece.freePoints.forEach(point => {
			if (point.marker) {
				point.marker.hide();
			}
		});
		if (that.linePiece.route.path) {
			that.linePiece.route.path.hide();
			that.linePiece.route.path.setOptions({
				strokeColor: baseColor
			});
		}
	};
	this.highLight = function() {
		if (that.linePiece.route.path) {
			that.linePiece.route.path.show();
			that.linePiece.route.path.setOptions({
				strokeColor: highLight
			});
		}
	};
	// 生成点标记点-产生单位
	this.markerShow = function(point, index) {
		// if (index == 0) {
		//   map.setZoomAndCenter(13, [point.lon, point.lat]);
		// }
		if (index == 0) {
			markers.forEach(item => {
				unitD(item);
			});
		}
		// point.marker = null;
		if (!point.marker) {
			let pointMarker = new AMap.Marker({
				map: map,
				position: new AMap.LngLat(point.lon, point.lat),
				icon: index == 0 ?
					"../../../static/img/ksh/starting.png" :
					index == that.linePiece.routePoints.length - 1 ?
					"../../../static/img/ksh/finishing.png" :
					""
				// label: {
				//   offset:
				//     index == 0 || index == that.linePiece.routePoints.length - 1
				//       ? new AMap.Pixel(54, 0)
				//       : new AMap.Pixel(35, -10),
				// content:
				//   index == 0 || index == that.linePiece.routePoints.length - 1
				//     ? point.unitName
				//       ? `<div><i></i><span class='span1' >${point.unitName}</span>`
				//       : ""
				//     : `<div ><i></i><span class='span1' >${
				//         point.unitName
				//       }</span><span class='span2'>${
				//         point.weight.length == 0 ? 0 : point.weight
				//       }kg</span></div>`,
				//   direction: "right"
				// }
			});

			if ($lableShow) {
				pointMarker.setLabel({
					offset: index == 0 || index == that.linePiece.routePoints.length - 1 ?
						new AMap.Pixel(54, 0) :
						new AMap.Pixel(35, -10), //设置文本标注偏移量
					// content: `<div class='info' style="padding:-5px 5px">${item.numberPlate ? item.numberPlate : ""}</div>`, //设置文本标注内容
					content: index == 0 || index == that.linePiece.routePoints.length - 1 ?
						point.unitName ?
						`<div><i></i><span class='span1' >${point.unitName}</span>` :
						"" :
						`<div ><i></i><span class='span1' >${
                  point.unitName
                }</span><span class='span2'>${
                  point.weight.length == 0 ? 0 : point.weight
                }kg</span></div>`, //设置文本标注内容
					direction: "right" //设置文本标注方位
				});
			} else {
				const infoWindow = new AMap.InfoWindow({
					offset: new AMap.LngLat(point.lon, point.lat)
				});
				pointMarker.on("mouseover", function(e) {
					infoWindow.setContent(
						index == 0 || index == that.linePiece.routePoints.length - 1 ?
						point.unitName ?
						`<div><i></i><span class='span1' >${point.unitName}</span>` :
						"" :
						`<div ><i></i><span class='span1' >${
                  point.unitName
                }</span><span class='span2'>${
                  point.weight.length == 0 ? 0 : point.weight
                }kg</span></div>`
					);
					infoWindow.open(map, new AMap.LngLat(point.lon, point.lat));
				});
				pointMarker.on("mouseout", function(e) {
					infoWindow.close(map, new AMap.LngLat(point.lon, point.lat));
				});
			}

			pointMarker.on("click", e => {
				plan1AddPoint(index);
			});
			// map.add(pointMarker);
			// pointMarker.setMap(map)
			// map.add([pointMarker])
			point.marker = pointMarker;
			markers.push(pointMarker);
			unitFormMap(pointMarker);
		} else {
			point.marker.show();
		}
	};
	// 生成点标记点-待选点
	this.markerShowTow = function(point2, index) {
		map.remove(markersTow);
		// // for(var i=0;i <= markersTow.length/2-1;i++){
		// //   unitD(markersTow[i])
		// //   markersTow[i].setMap(null);
		// // }
		markersTow.forEach(item => {
			unitD(item);
			// item.setMap(null);
		});
		// !point2.marker
		if (point2.marker) {
			let pointMarker = new AMap.Marker({
				position: new AMap.LngLat(point2.lon, point2.lat),
				// label: {
				//   offset: new AMap.Pixel(38, -10),
				//   content: `<div><i></i><span class='span1'>${point2.unitName}</span><span class='span2'>${point2.weight.length == 0 ? 0 : point2.weight} kg</span></div>`,
				//   direction: 'right'
				// },
				icon: new AMap.Icon({
					image: that.opt == "edit" ?
						"https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png" :
						"https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png",
					size: new AMap.Size(16, 26), //图标大小
					imageSize: new AMap.Size(16, 26)
				})
			});

			if ($lableShow) {
				pointMarker.setLabel({
					offset: new AMap.Pixel(33, -10), //设置文本标注偏移量
					// content: `<div class='info' style="padding:-5px 5px">${item.numberPlate ? item.numberPlate : ""}</div>`, //设置文本标注内容
					content: `<div><i></i><span class='span1'>${
            point2.unitName
          }</span><span class='span2'>${
            point2.weight.length == 0 ? 0 : point2.weight
          } kg</span></div>`, //设置文本标注内容
					direction: "right" //设置文本标注方位
				});
			} else {
				const infoWindow = new AMap.InfoWindow({
					offset: new AMap.Pixel(0, -30)
				});
				pointMarker.on("mouseover", function(e) {
					console.log(e);
					infoWindow.setContent(
						`<div ><span class='span1'>${
              point2.unitName
            }</span><span class='span2'>${
              point2.weight.length == 0 ? 0 : point2.weight
            } kg</span></div>`
					);
					infoWindow.open(map, new AMap.LngLat(point2.lon, point2.lat));
				});
				pointMarker.on("mouseout", function(e) {
					console.log(e);
					infoWindow.close(map, new AMap.LngLat(point2.lon, point2.lat));
				});
			}

			pointMarker.on("click", e => {
				if (that.opt == "edit") {
					plan1AddPointTow(index);
				}
			});
			map.add(pointMarker);
			point2.marker = pointMarker;
			unitFormMap(pointMarker);
		} else {
			point2.marker.show();
		}
	};
	// 生成点标记点-初始化待选点
	this.markerShowForu = function(point2, index) {
		if (index == 0) {
			markersTow.forEach(item => {
				unitD(item);
			});
		}
		// markersTow.forEach(item => {
		//   unitD(item)
		// })
		if (!point2.marker) {
			let pointMarker = new AMap.Marker({
				position: new AMap.LngLat(point2.lon, point2.lat),
				// label:labelShow? {
				//   offset: new AMap.Pixel(38, -10),
				//   content: `<div><i></i><span class='span1'>${point2.unitName}</span><span class='span2'>${point2.weight.length == 0 ? 0 : point2.weight} kg</span></div>`,
				//   direction: 'right'
				// }:"",
				icon: new AMap.Icon({
					image: "https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png",
					size: new AMap.Size(16, 26), //图标大小
					imageSize: new AMap.Size(16, 26)
				})
			});
			if ($lableShow) {
				pointMarker.setLabel({
					offset: new AMap.Pixel(33, -10), //设置文本标注偏移量
					// content: `<div class='info' style="padding:-5px 5px">${item.numberPlate ? item.numberPlate : ""}</div>`, //设置文本标注内容
					content: `<div><i></i><span class='span1'>${
            point2.unitName
          }</span><span class='span2'>${
            point2.weight.length == 0 ? 0 : point2.weight
          } kg</span></div>`, //设置文本标注内容
					direction: "right" //设置文本标注方位
				});
			} else {
				const infoWindow = new AMap.InfoWindow({
					offset: new AMap.Pixel(0, -30)
				});
				pointMarker.on("mouseover", function(e) {
					console.log(e);
					infoWindow.setContent(
						`<div ><span class='span1'>${
              point2.unitName
            }</span><span class='span2'>${
              point2.weight.length == 0 ? 0 : point2.weight
            } kg</span></div>`
					);
					infoWindow.open(map, new AMap.LngLat(point2.lon, point2.lat));
				});
				pointMarker.on("mouseout", function(e) {
					console.log(e);
					infoWindow.close(map, new AMap.LngLat(point2.lon, point2.lat));
				});
			}

			pointMarker.on("click", e => {
				if (that.opt == "edit") {
					plan1AddPointTow(index);
				} else {
					refStartEnd();
				}
			});

			map.add(pointMarker);
			point2.marker = pointMarker;
			markersTow.push(pointMarker);
			// let freeLength=1
			// if(freeLength !=that.linePiece.freePoints.length){
			//    unitFormMap(pointMarker)
			//    freeLength++
			// }
			unitFormMap(pointMarker);
		} else {
			point2.marker.show();
		}
	};
	// 生成点标记点-选中状态的点
	this.markerShowThree = (point, index) => {
		for (var i = 0; i < markers.length; i++) {
			markers[i].setAnimation(); //清除跳动动画
		}
		map.setCenter([point.lon, point.lat]);
		point.marker.setAnimation("AMAP_ANIMATION_BOUNCE");
	};
	this.showAllPoint = function() {
		that.linePiece.routePoints.forEach(point => {
			that.markerShow(point);
		});
		that.linePiece.freePoints.forEach((point, index) => {
			that.markerShowTow(point, index);
		});
	};
	this.startEdit = function(callback) {
		that.opt = "edit";
		that.highLight();
		that.showAllPoint();
		if (callback && typeof callback == "function") callback();
	};
	return this;
}



// WEBPACK FOOTER //
// ./src/components/map/lib/planLine.js